<template>
    <div class="wrapper">
        <div class="main-panel">
            <div class="main-content">
                <div class="content-wrapper">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="px-3">
                                            <h2>Drug report</h2>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="startDate">{{ $t("labels.startDate") }}</label>
                                                        <date-picker v-model="drugFilters.startDate" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="endDate">{{ $t("labels.endDate") }}</label>
                                                        <date-picker v-model="drugFilters.endDate" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="form-group bottom-space">
                                                        <label for="drugType">{{ $t("labels.drugType") }}</label>
                                                        <select class="form-control" v-model="drugFilters.drugType">
                                                            <option value="nofilter">{{ $t("labels.nofilter") }}</option>
                                                            <option value="drug">{{ $t("labels.drug") }}</option>
                                                            <option value="life_saving_drug">{{ $t("labels.lifeSavingDrug") }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="custom-control custom-checkbox bottom-space">
                                                        <input type="checkbox" class="custom-control-input" id="patientAgeFilter" v-model="drugFilters.patientAgeFilter">
                                                        <label class="custom-control-label float-left" for="patientAgeFilter">{{ $t("labels.patientAgeFilter") }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" v-if ="drugFilters.patientAgeFilter">
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label for="status">{{ $t("labels.ageMin") }}</label>
                                                        <div class="position-relative has-icon-left">
                                                            <input type="number" v-model="drugFilters.ageMin">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label for="status">{{ $t("labels.ageMax") }}</label>
                                                        <div class="position-relative has-icon-left">
                                                            <input type="number" v-model="drugFilters.ageMax">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <button class="btn btn-success" @click.prevent="searchDrugs">{{ $t("labels.search") }}</button>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <table class="table">
                                                        <thead>
                                                            <th>
                                                                {{ $t("labels.drug") }}
                                                            </th>
                                                            <th>
                                                                {{ $t("labels.times") }}
                                                            </th>
                                                            <th>
                                                                {{ $t("labels.patients") }}
                                                            </th>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="drug in drugs" :key="drug.name">
                                                                <td>
                                                                    {{ drug.name[$i18n.locale] ? drug.name[$i18n.locale] : drug.name['en'] }}
                                                                </td>
                                                                <td>
                                                                    {{ drug.times }}
                                                                </td>
                                                                <td>
                                                                    {{ drug.patients }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <a href="" class="btn btn-success" @click.prevent="comparePeriods">{{ $t("labels.compareDrugs") }} - {{ formatDate(compareStart) }} - {{ formatDate(drugFilters.startDate) }}</a>
                                                </div>
                                                <div class="col-md-6" v-if="drugsCompare.length > 0">
                                                    <table class="table">
                                                        <thead>
                                                            <th>
                                                                {{ $t("labels.drug") }}
                                                            </th>
                                                            <th>
                                                                {{ $t("labels.times") }}
                                                            </th>
                                                            <th>
                                                                {{ $t("labels.patients") }}
                                                            </th>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="drug in drugsCompare" :key="drug.name">
                                                                <td>
                                                                    {{ drug.name[$i18n.locale] ? drug.name[$i18n.locale] : drug.name['en'] }}
                                                                </td>
                                                                <td>
                                                                    {{ drug.times }}
                                                                </td>
                                                                <td>
                                                                    {{ drug.patients }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SeizureService from '@/services/seizure'
import PatientService from '@/services/patient'
import moment from 'moment'

export default {
    data() {
        return {
            drugs: [],
            drugsCompare: [],
            drugFilters: {
                startDate: moment(new Date()).startOf('month').format('YYYY-MM-DD'),
                endDate: moment(new Date()).endOf('month').format('YYYY-MM-DD'),
                drugType: '',
                patientAgeFilter: false,
                ageMin: 0,
                ageMax: 30
            }
        }
    },
    computed: {
        compareStart() {
            let start = new Date(this.drugFilters.startDate)
            let end = new Date(this.drugFilters.endDate)
            let duration = new Date(start - (end - start))
            return duration
        }
    },
    methods: {
        searchDrugs: async function() {
            if (this.drugFilters.drugType === 'life_saving_drug') {
                let result = await SeizureService.drugSearch(this.drugFilters)
                if (result) {
                    this.drugs = result.data
                }
            } else {
                let result = await PatientService.drugSearch(this.drugFilters)
                if (result) {
                    this.drugs = result.data
                }
            }
        },
        comparePeriods: async function() {
            let compareFilters = {
                startDate: this.compareStart,
                endDate: this.drugFilters.startDate,
                drugType: this.drugFilters.drugType,
                patientAgeFilter: this.drugFilters.patientAgeFilter,
                ageMin: this.drugFilters.ageMin,
                ageMax: this.drugFilters.ageMax
            }
            if (this.drugFilters.drugType === 'life_saving_drug') {
                let result = await SeizureService.drugSearch(compareFilters)
                if (result) {
                    this.drugsCompare = result.data
                }
            } else {
                let result = await PatientService.drugSearch(compareFilters)
                if (result) {
                    this.drugsCompare = result.data
                }
            }
        },
        formatDate(d) {
            return moment(new Date(d)).format("YYYY-MM-DD")
        }
    },
    mounted: async function() {
        await this.searchDrugs()
    }
}
</script>

<style lang="scss">
    .px-3 {
        padding: 15px;
    }
</style>


